import { sourceKey } from "../lib/data";
import { useStore } from "../store";
import type { DataSource, DataState } from "../types";

const LOADING: DataState = { status: "loading", columns: [], rows: [] };

/**
 * Read one widget's rows from the store.
 *
 * Deliberately does NOT fetch. In the desktop build each widget fetched itself,
 * which meant a page issued one request per widget; here the page loads all of
 * them in a single batch (`store.loadPage`) so the server can dedupe identical
 * SQL and run the rest concurrently. This hook is a pure subscription.
 */
export function useWidgetData(source: DataSource): DataState {
  const connId = useStore((s) => s.activeConnectionId);
  const state = useStore((s) => s.dataCache[sourceKey(source, connId)]);
  return state ?? LOADING;
}
